import { Location } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {RouteUtils} from "./utils/route.utils";

const routes: Routes = [
  {
    path: RouteUtils.PAGES.LOGIN,
    loadChildren: () => import('./login/login.module').then(m => m.LoginModule),
  },
  {
    path: '**',
    redirectTo: RouteUtils.PAGES.LOGIN,
  },
];

@NgModule({
  declarations: [],
  imports: [RouterModule.forRoot(routes)],
  providers: [Location],
  exports: [RouterModule],
})
export class AppRoutingModule {}
